export const environment = {
  	production: true,
	// recaptcha_site_key: '6LcLh-AeAAAAAOrfKXglzY6TUcIEoXeAew5sLxLu',
	// recaptcha_secret_key: '6LcLh-AeAAAAAPCQSTi2L8tQHg-cImE_58fsG7PF',
	recaptcha_site_key: '6Lc4muAeAAAAABAQXT39m4qMO_994-Zz2EzdHkQD',
	recaptcha_secret_key: '6Lc4muAeAAAAAOHsDtmWHDvpNE5k7m7v9UnqhoVv',
	enable_recaptcha: false,
	turnstileSiteKey: '0x4AAAAAABlKO_yjqCx3G7Jg',
	turnstileExpiry: 60, // in minutes
};
